import { debounce } from './utility.js';

import gsap from 'gsap';
import ScrollToPlugin from 'gsap/ScrollToPlugin';
import ScrollTrigger from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollToPlugin);
gsap.registerPlugin(ScrollTrigger);

// ナビゲーション高さをオフセット値としてスクロール
const scrollToTarget = (target) => {
    const header = document.querySelector('.layout-header');

    gsap.to(window, {
        duration: 1,
        scrollTo: { y: window.pageYOffset + target.getBoundingClientRect().top - header.clientHeight, autoKill: false },
        ease: 'power4.out'
    });
};

const setupAnchorLink = () => {
    document.querySelectorAll('a[href*="#"]').forEach((anchor) => {
        const currentPagePath = window.location.pathname;
        const anchorHrefPath = new URL(anchor.href).pathname;

        if (anchorHrefPath === currentPagePath || anchorHrefPath === '') {
            anchor.addEventListener('click', (event) => {
                event.preventDefault();

                const href = anchor.getAttribute('href');
                const targetId = href.includes('#') ? href.substring(href.indexOf('#')) : '';
                if (!targetId) return;

                const target = document.querySelector(targetId);
                if (!target) return;

                scrollToTarget(target);
            });
        }
    });
};

// ページインのアニメーション
const setupInviewAnimation = () => {
    gsap.utils.toArray('.js-inview').forEach(el => {
        ScrollTrigger.create({
            trigger: el,
            start: 'top 80%',
            toggleClass: 'is-inview',
            once: true
        });
    });
};

// ページインのアニメーション
const setupCounterAnimation = () => {
    document.querySelectorAll('.js-counter').forEach((counter) => {
        counter.querySelectorAll('.js-counter-target').forEach((target) => {
            const elementDic = {
                from:target.dataset.from,
                to:target.dataset.to
            }
            const elementNum = {count:elementDic.from};
            gsap.to(elementNum,{
                count:elementDic.to,
                duration: 1,
                ease: 'none',
                scrollTrigger:{
                    trigger:counter,
                    start: 'top 80%',
                },
                onUpdate:()=>{
                    target.textContent = Math.floor(elementNum.count);
                }
            })
        });
    });
};

// ボタンのアニメーション
const setupButtonAnimation = () => {
    document.querySelectorAll('.component-button a').forEach(function(button) {
        button.addEventListener('mouseenter', function(event) {
            const span = this.querySelector('span');
            if (span) {
                const parentOffset = this.getBoundingClientRect(),
                    relX = event.pageX - parentOffset.left - window.pageXOffset,
                    relY = event.pageY - parentOffset.top - window.pageYOffset;
                span.style.cssText = `top:${relY}px; left:${relX}px;`;
            }
        });

        button.addEventListener('mouseout', function(event) {
            const span = this.querySelector('span');
            if (span) {
                const parentOffset = this.getBoundingClientRect(),
                    relX = event.pageX - parentOffset.left - window.pageXOffset,
                    relY = event.pageY - parentOffset.top - window.pageYOffset;
                span.style.cssText = `top:${relY}px; left:${relX}px;`;
            }
        });
    });
}

const drawWaveAnimation = () => {
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    const waveElement = document.querySelector('.component-page-header__wave');
    const waveLightBlueElement = document.querySelector('.component-page-header__wave--light-blue');

    if (!waveElement || !ctx) return;

    const setCanvasSize = () => {
        canvas.width = window.innerWidth;
        canvas.height = waveElement.clientHeight;
    };

    setCanvasSize();
    waveElement.appendChild(canvas);

    const waveParams = { waveOffset: 0 };
    const waveHeight = waveElement.clientHeight / 3;
    const waveFrequency = 0.0025;

    const drawWave = () => {
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        ctx.beginPath();

        for (let i = 0; i < canvas.width; i++) {
            const wave = waveHeight * Math.sin(i * waveFrequency + waveParams.waveOffset);
            ctx.lineTo(i, wave + canvas.height / 2);
        }

        ctx.lineTo(canvas.width, canvas.height);
        ctx.lineTo(0, canvas.height);
		if(!waveLightBlueElement){
			ctx.fillStyle = '#fff';
		} else {
			ctx.fillStyle = '#eefaff';
		}
        ctx.fill();

        requestAnimationFrame(drawWave);
    };

    gsap.to(waveParams, {
        duration: 3.5,
        ease: 'power1.out',
        waveOffset: 6.5,
        onUpdate: () => {
        }
    });

    window.addEventListener('resize', debounce(
		() => {
			setCanvasSize();
			drawWave();
		}
	));

    drawWave();
};

export const initAnimation = () => {
	setupAnchorLink();
    setupInviewAnimation();
	setupCounterAnimation();
	setupButtonAnimation();
	drawWaveAnimation();
};